export default "__VITE_ASSET___TB28I$Q__"